module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators-2-w720.daea1581.jpg";